/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import { getInterfaceDict } from "@/utils/dev/interface-run";
import utils from "@/utils/localstore/Index.js"
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        paperId: ""
    },
    mutations: {},
    actions: {
        //获取课程
        async getCourse ({ state }, courseId) {
            let courseRes = await this.$axios.get(
                `/api/CourseManage/Distribute/GetCpuListInUnit/${courseId}`
            );
            state.name = null
            let row = courseRes.data.Course[0];
            let { courseid, courseplanuserid: cpuId, id: cpcId } = row;

            utils.setLocalStorage("courseId", courseid);
            utils.setCpuId(cpuId);
            utils.setCpcId(cpcId);
            utils.setLocalStorage('courseCompletedstatus', row.completedstatus);
            //开启课程
            if (row.completedstatus == "0") {
                await this.$axios.post(
                    "/api/CourseManage/Process/OpenCourseForUser", {
                    CpuId: cpuId
                }
                );
            }
        },
        //获取课程节点
        async getCourseNode ({ state, dispatch }, cpuId) {
            let cpcId = utils.getCpcId()
            let curNodeIdRes = await this.$axios.get(
                `/api/CourseManage/Process/GetCurrentNodeId?cpuId=${cpuId}`
            );
            localStorage.setItem('courseCompletedstatus', curNodeIdRes.data.resultdata.CompletedStatus);
            state.paperId = curNodeIdRes.data.resultdata.CourseContent.ExtendInfo.PaperId;

            if (curNodeIdRes.data.type === 1) {
                let { nodes, lines } = curNodeIdRes.data.resultdata.CourseContent.Units;
                let { ActivityId } = curNodeIdRes.data.resultdata;
                let starId = "",
                    nodeId = "",
                    modelId = "";
                //找出开始节点
                for (var i = 0; i < nodes.length; i++) {
                    if (nodes[i].type === "stepgroup" && nodes[i].id === ActivityId) {
                        //分组  开始环节
                        await this.$axios.post(
                            "/api/Utils/Log/NodeStart", {
                            cpuId: cpuId,
                            cpcId,
                            nodeId: nodes[i].id
                        }
                        );
                        await this.$axios.post(
                            "/api/Utils/Log/NodeCompleted", {
                            cpuId: cpuId,
                            cpcId,
                            nodeId: nodes[i].id
                        }
                        );
                        dispatch('getCourseNode', cpuId)
                    }
                    if (nodes[i].type == "startround") {
                        starId = nodes[i].id;
                        // break;
                    }
                }
                nodes = sortNode(starId, lines, nodes, []);
                nodes.forEach((v) => {
                    if (v.type === "bigdata") {
                        modelId = v.setInfo.NodeModelId;
                        nodeId = v.id;
                        utils.setLocalStorage("nodeModelId", modelId);
                        utils.setLocalStorage("nodeId", nodeId);
                    }
                });
                utils.setLocalStorage("nodes", nodes);
                utils.getLocalStorage(
                    "interfaceDic_" + modelId
                );

            } else {
                alert('获取课程节点失败')
            }
        }
    },
    modules: {}
});

function sortNode (from, lines, list, newList) {
    for (var i = 0; i < lines.length; i++) {
        if (lines[i].from == from) {
            for (var k = 0; k < list.length; k++) {
                if (
                    lines[i].to == list[k].id &&
                    list[k].type != "stepgroup" &&
                    list[k].type != "endround"
                ) {
                    newList.push(list[k]);
                }
            }
            newList = sortNode(lines[i].to, lines, list, newList);
            break;
        }
    }
    return newList;
}